import React, { useState, useEffect } from 'react';
import { Drawer } from 'antd';

const CustomDrawer = ({ children, width = 600, ...props }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <style>{`
        @media (max-width: 767px) {
          .custom-drawer-right-close .ant-drawer-header-title {
            display: flex !important;
            flex-direction: row-reverse !important;
            align-items: center !important;
            justify-content: space-between !important;
            width: 100% !important;
          }
          .custom-drawer-right-close .ant-drawer-title {
            flex: 1 !important;
            min-width: 0 !important;
          }
          .custom-drawer-right-close .ant-drawer-close {
            margin-inline-end: 0 !important;
            margin-inline-start: 12px !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
          }
        }
      `}</style>
      <Drawer
        {...props}
        className={`custom-drawer-right-close ${props.className || ''}`}
        placement={isMobile ? 'bottom' : 'right'}
        width={isMobile ? '100%' : width}
        height={isMobile ? '80vh' : '100%'}
        style={{
          borderTopLeftRadius: isMobile ? 16 : 0,
          borderTopRightRadius: isMobile ? 16 : 0,
          ...props.style
        }}
      >
        {children}
      </Drawer>
    </>
  );
};

export default CustomDrawer;
